import pt from './locales/pt';

let config = ($translateProvider) => {
	$translateProvider.translations('pt', pt);
	$translateProvider.preferredLanguage('pt');
	$translateProvider.useSanitizeValueStrategy('escape');
}

config.$inject = ['$translateProvider'];

export default config;


// WEBPACK FOOTER //
// ./client/app/config/translate-provider-config.js